// extracted by mini-css-extract-plugin
export default {"container":"EditorMenuControl_container__yZNWw","tooltip":"EditorMenuControl_tooltip__OVrVr"};